import React, { useState } from 'react'
import { Fetch } from '../../services/api'
import { notify, urlApiPlamin } from '../../utils/utils'

export const usePrincipal = () => {
  
  const listarAlertasPorEmpresa = async () => {
    const response = await Fetch({
      url: urlApiPlamin + '/cantidadAlertasPorEmpresa'
    })

    !response.isValid && notify(response.exceptions[0].description)

    return (
      response.isValid 
      ? {
          empresas: Object.groupBy(response.content, e => e.nomEmpresa), 
          alertas: Object.groupBy(response.content, e => e.nomAlerta)
        } 
      : {}
    )
  }

  const listarOperatividadPorEmpresa = async () => {
    const response = await Fetch({
      url: urlApiPlamin + '/operatividadPorEmpresa'
    })

    !response.isValid && notify(response.exceptions[0].description, 'error')

    return response.isValid ? response.content : []
  }

  const listarTotalOperatividades = async () => {
    const response = await Fetch({
      url: urlApiPlamin + '/listaOperatividad'
    })

    !response.isValid && notify(response.exceptions[0].description, 'error')

    return response.isValid ? response.content : {}
  }
  
  return {
    listarAlertasPorEmpresa,
    listarOperatividadPorEmpresa,
    listarTotalOperatividades
  }

  
}
